import { Typography, TypographyProps, styled } from '@mui/material';
import { sanguine, spaceCadet, ultraMarine } from '../../../../../../../../../../../utils/colors';

interface DetectionInformationProps extends TypographyProps {
  isHighlighted: boolean;
  isFromClient?: boolean;
  isIntention?: boolean;
  density?: 'panel' | 'page';
}

const StyledTypography = styled((props: DetectionInformationProps) => {
  const {
    isHighlighted, isFromClient, isIntention, density, ...other
  } = props;
  return <Typography {...other} />;
})(({
  isHighlighted, isFromClient, isIntention, density,
}) => ({
  fontSize: density === 'page' ? 12 : 9,
  lineHeight: 2,
  display: 'flex',
  alignItems: 'center',
  gap: 4,
  color: isHighlighted ? ultraMarine[500] : spaceCadet[400],
  '& strong': {
    color: isHighlighted ? ultraMarine[500] : spaceCadet[500],
    ...isIntention && {
      textDecoration: 'underline',
    },
  },

  '& > .MuiSvgIcon-root': {
    fontSize: 14,
    color: isFromClient ? sanguine[400] : ultraMarine[400],
  },
}));

export default StyledTypography;
